import { supabase } from './supabase';

export type AnalyticsEvent =
  | 'sign_in'
  | 'export_free'
  | 'pro_preset_used'
  | 'upgrade_modal_shown'
  | 'checkout_started'
  | 'checkout_completed'
  | 'preset_saved'
  | 'sign_up_email_confirmed'
  | 'settings_opened'
  | 'plan_page_viewed'
  | 'upgrade_clicked'
  | 'template_opened_from_library';

/**
 * Fire-and-forget analytics event. Never awaited; never blocks the UI.
 * Falls back silently if Supabase is not configured.
 */
export function track(
  event: AnalyticsEvent,
  props?: Record<string, unknown>,
): void {
  const userId = supabase.auth.getSession()
    .then(({ data }) => data.session?.user?.id ?? null)
    .catch(() => null);

  userId.then(user_id => {
    supabase.from('analytics_events').insert({ event, user_id, props }).then(() => {});
  });
}
